// Material metadata for display across the app
// Resistance levels: 1-5 (5 = max)

const MATERIAL_META = {
  'Sencillo 3 mm': {
    description: 'Cartón ligero ideal para envíos pequeños y productos de bajo peso.',
    resistance: 2,
    image: 'https://customer-assets.emergentagent.com/job_a5a63ab2-e6ce-4f04-9a31-0beec38ff3e2/artifacts/mybxk9sk_IMG_7145.JPG',
    shortDesc: 'Ideal para productos ligeros y envíos estándar.',
  },
  'Doble 5 mm': {
    description: 'Mayor resistencia, recomendado para productos pesados o frágiles.',
    resistance: 5,
    image: 'https://customer-assets.emergentagent.com/job_a5a63ab2-e6ce-4f04-9a31-0beec38ff3e2/artifacts/jqpnauov_IMG_7144.PNG',
    shortDesc: 'Mayor resistencia para productos pesados o frágiles.',
  },
  'Sencillo Blanco': {
    description: 'Acabado blanco ideal para impresión de alta calidad.',
    resistance: 2,
    image: 'https://customer-assets.emergentagent.com/job_a5a63ab2-e6ce-4f04-9a31-0beec38ff3e2/artifacts/lgxhyt57_corrugadosencilloblanca.jpg',
    shortDesc: 'Acabado blanco para mejor calidad de impresión.',
  },
  'Doble Blanco': {
    description: 'Resistencia máxima con acabado premium para mejor presentación.',
    resistance: 5,
    image: 'https://customer-assets.emergentagent.com/job_a5a63ab2-e6ce-4f04-9a31-0beec38ff3e2/artifacts/pho287ul_blancadoblecorrugado.png',
    shortDesc: 'Resistencia máxima con presentación premium.',
  },
};

export function getMaterialMeta(name) {
  return MATERIAL_META[name] || {
    description: '',
    resistance: 3,
    image: 'https://images.unsplash.com/photo-1579760546930-32bb6902a07d?w=400&h=400&fit=crop',
    shortDesc: '',
  };
}

export default MATERIAL_META;
